import React from 'react';
import { Outlet } from 'react-router-dom';

import '../../Mobile.css';
function Person() {

  return (
    <>
      <Outlet />
    </>
  );
}

export default Person